import { $ } from "@/common/Axios";

export default {
  /**
   * 学生就业记录
   */
  studentJobRecord_remark: {
    /*
     * 备注
     * id 记录id (integer query required)
     * remark 备注 (string query required)
     */
    put: (p, c) => $.put("/api/zms/content/studentJobRecord/remark", p, c),
  },
  studentJobRecord: {
    /*
     * 添加
     * studentJobRecord  ( query required)
     */
    post: (p, c) => $.post("/api/zms/content/studentJobRecord", p, c),
  },
  studentJobRecord_listStudentJob: {
    /*
     * 学生就业情况列表
     * classRoomId 班级id (integer query required)
     * name 姓名 (string query )
     */
    get: (p, c) =>
      $.get("/api/zms/content/studentJobRecord/listStudentJob", p, c),
  },
  studentJobRecord_listRecord: {
    /*
     * 学生就业记录列表
     * schoolRollId 合同id (integer query required)
     */
    get: (p, c) => $.get("/api/zms/content/studentJobRecord/listRecord", p, c),
  },
  studentJobRecord_listClassJob: {
    /*
     * 班级就业情况列表
     */
    get: (p, c) =>
      $.get("/api/zms/content/studentJobRecord/listClassJob", p, c),
  },
  studentJobRecord_listClassJobByDomain: {
    /*
     * 班级就业情况列表
     */
    get: (p, c) =>
      $.get("/api/zms/content/studentJobRecord/listClassJobByDomain", p, c),
  },

  /**
   * 学生家庭作业
   */
  studentHomework: {
    /*
     * 编辑
     * studentHomework  ( query required)
     */
    put: (p, c) => $.put("/api/zms/content/studentHomework", p, c),
  },
  studentHomework_upload: {
    /*
     * 批量导入
     * homeworkId 作业id (integer query required)
     * excelFile  (string body required)
     */
    post: (p, c) => $.post("/api/zms/content/studentHomework/upload", p, c),
  },
  studentHomework_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/zms/content/studentHomework/list", p, c),
  },
  studentHomework_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/zms/content/studentHomework/export", p, c),
  },
  studentHomework_downloadModule: {
    /*
     * 下载模板
     */
    get: (p, c) =>
      $.get("/api/zms/content/studentHomework/downloadModule", p, c),
  },

  /**
   * 职教通学校内容
   */
  siteContent: {
    /*
     * 添加
     * content  ( query required)
     */
    post: (p, c) => $.post("/api/zms/content/siteContent", p, c),

    /*
     * 删除
     * id 内容id (integer query required)
     */
    delete: (p, c) => $.delete("/api/zms/content/siteContent", p, c),
  },
  siteContent_listStudentStyle: {
    /*
     * 学生风采列表
     */
    get: (p, c) => $.get("/api/zms/content/siteContent/listStudentStyle", p, c),
  },
  siteContent_listStudentStyleForClient: {
    /*
     * 学生风采列表
     * type 类型：学生、家长 (string query required)
     * phone 手机号，家长的时候填写 (string query )
     */
    get: (p, c) =>
      $.get("/api/zms/content/siteContent/listStudentStyleForClient", p, c),
  },
  siteContent_listStudentStyleBannerForClient: {
    /*
     * 学生风采轮播图列表
     * type 类型：学生、家长 (string query required)
     * phone 手机号，家长的时候填写 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/zms/content/siteContent/listStudentStyleBannerForClient",
        p,
        c
      ),
  },

  /**
   * 职教通学校内容点赞
   */
  siteContentLike: {
    /*
     * 点赞|取消
     * contentId 内容id (integer query required)
     * type 类型：学生、家长 (string query required)
     * phone 手机号，家长的时候填写 (string query )
     */
    post: (p, c) => $.post("/api/zms/content/siteContentLike", p, c),
  },

  /**
   * 家庭作业
   */
  homework: {
    /*
     * 添加
     * homework  ( query required)
     */
    post: (p, c) => $.post("/api/zms/content/homework", p, c),

    /*
     * 删除
     * id 内容id (integer query required)
     */
    delete: (p, c) => $.delete("/api/zms/content/homework", p, c),
  },
  homework_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/zms/content/homework/list", p, c),
  },
  homework_listSimple: {
    /*
     * 简易列表
     * teachingPlanId 教学计划id (integer query required)
     */
    get: (p, c) => $.get("/api/zms/content/homework/listSimple", p, c),
  },
  homework_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/zms/content/homework/export", p, c),
  },
};
